// CCTV game copy. Each CCTV game type maps 1:1 to one detection
// class — irl/irl_alt → vehicles, snow_run → people, duck_river →
// ducks, social_betting → creator-uploaded content (any class, so the
// copy stays generic). Centralised here so the StreamRoundIntro headline and the
// chip-placement notice (round-open + betting-closed disclaimers)
// always read identically without duplicating the strings.
//
// Strings live as `t(...)` calls inside this module so the i18n
// extractor (`src/services/i18n/bin/extractKeys.js`) can pick them
// up — its regex only matches direct string-literal arguments to
// the `t` function, not variables. Consumers pass the active `t`
// function in.

type TranslateFn = (key: string) => string

const COPY_BUILDERS: Record<string, (t: TranslateFn) => { headline: string; disclaimer: string }> =
  {
    irl: (t) => ({
      headline: t('HOW MANY VEHICLES?'),
      disclaimer: t('Only vehicles detected by the AI will be counted')
    }),
    irl_alt: (t) => ({
      headline: t('HOW MANY VEHICLES?'),
      disclaimer: t('Only vehicles detected by the AI will be counted')
    }),
    social_betting: (t) => ({
      // Deliberately matches the `HOW MANY <NOUN>?` shape of the
      // sibling builders but elides the noun because social_betting
      // is creator-uploaded content (any class). The disclaimer
      // below + the round's subtitle + the numeric betting tiles
      // disambiguate "many what" — keeps the banner short enough
      // to fit one line on mobile.
      headline: t('HOW MANY?'),
      disclaimer: t('Only what the AI detects will be counted')
    }),
    snow_run: (t) => ({
      headline: t('HOW MANY PEOPLE?'),
      disclaimer: t('Only people detected by the AI will be counted')
    }),
    duck_river: (t) => ({
      headline: t('HOW MANY DUCKS?'),
      disclaimer: t('Only ducks detected by the AI will be counted')
    })
  }

export function getCCTVCopy(
  gameType: string,
  t: TranslateFn
): { headline: string; disclaimer: string } | null {
  const builder = COPY_BUILDERS[gameType]
  return builder ? builder(t) : null
}
